import { Box, Typography } from "@mui/material";
import LeftMenu from "./menus/LeftMenu";
import HeaderBar from "./headers/HeaderBar";
import { useTheme } from "@mui/material/styles";
import { useContext } from "react";
import { LanguageContext } from "../context/LanguageContext";

export default function IntegrationsDesktop() {
  const theme = useTheme();
  const { translate } = useContext(LanguageContext);

  return (
    <Box
      sx={{
        display: "flex",
        width: "100%",
        bgcolor: "background.default",
        color: "text.primary",
        minHeight: "100vh",
      }}
    >
      <LeftMenu />
      <Box sx={{ flex: 1, p: 3 }}>
        <HeaderBar
          title={translate("Integrations")}
          subtitle={translate("Connect Talkmate to your tools")}
        />
        <Box sx={{ mt: 3 }}>
          <Typography
            variant="body1"
            sx={{ color: theme.palette.text.secondary }}
          >
            {translate("IntegrationsPagePlaceholder") ||
              "Connect Talkmate with your website, CRM, or support platform."}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
}
